import React, {FC, ReactNode} from 'react';

import {SandboxScenariosEnum} from '../../../../helpers/sandbox/sandboxScenarioHelpers';
import {MentionEducationTip} from './mentionEducationTip';
import {SandboxEducationTipCoordinator} from './sandboxEducationTipCoordinator';

/*
 * Props.
 */

interface MentionEducationTipCoordinatorProps {
  className?: string;
  conversationId: number | undefined;
  isEditingExistingComment: boolean;
  children: ReactNode;
}

/*
 * Component.
 */

export const MentionEducationTipCoordinator: FC<MentionEducationTipCoordinatorProps> = (props) => {
  if (props.isEditingExistingComment) {
    return <>{props.children}</>;
  }

  return (
    <SandboxEducationTipCoordinator
      className={props.className}
      conversationId={props.conversationId}
      scenario={SandboxScenariosEnum.SCENARIO3_ACT1}
      step="mention-marisa"
      isEligible
      EducationTip={MentionEducationTip}
    >
      {props.children}
    </SandboxEducationTipCoordinator>
  );
};
